import { Navigate } from "react-router-dom";
import { AdminPermissions } from "@/enums";
import { isNumber } from "@/utils";
import { SettingsHelper } from "@/helpers";

export type AdminRouteProps = {
  isAdminMode: boolean;
  requiredPermission?: AdminPermissions;
  currentPermissions?: AdminPermissions;
  children: any;
};

const AdminRoute: React.FC<AdminRouteProps> = ({
  isAdminMode,
  requiredPermission,
  currentPermissions,
  children,
}) => {
  if (
    !isAdminMode ||
    (isNumber(requiredPermission) && !isNumber(currentPermissions)) ||
    (isNumber(requiredPermission) &&
      isNumber(currentPermissions) &&
      !SettingsHelper.hasPermission(currentPermissions, requiredPermission))
  ) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default AdminRoute;
